export default __webpack_public_path__ + "static/media/path_11.a05a52f2.png";